






















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GCheckboxWorkFormInput',
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    valid: { type: Boolean as PropType<boolean>, default: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    label: { type: String as PropType<string> },
    // disabled: { type: Boolean as PropType<boolean>, default: false },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    isCheckBoxTwoLines: { type: Boolean as PropType<boolean>, default: false },
    value: { type: Array as PropType<number[]>, default: () => [] },
    error: { type: Array as PropType<string[]>, default: () => [] },
  },
  computed: {
    innerValue: {
      get(): number[] {
        return this.value;
      },
      set(val: number[]): void {
        this.$emit('input', val);
      },
    },
  },
});
